<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Integrate Device(s)'"
      [canGoBack]="true"
      [noBow]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="form">
    <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

      @if (loaded) {
        <tidy-card>
          <tidy-row class="vertical-align-center">
            @if (isAssociatedWithAddress) {
              <tidy-image
                [src]="'assets/img/checkmark.svg'"
                class="header-size" />
            }
            @if (!isAssociatedWithAddress) {
              <tidy-image
                [src]="'assets/img/block.svg'"
                class="body-size" />
            }
            @if (!address?.address_name) {
              <tidy-text
                [body]="address?.address1 + ' '"
                [translate]="false" />
            }
            @if (address?.address_name) {
              <tidy-text
                [body]="address?.address_name"
                [translate]="false" />
            }
          </tidy-row>
          @if (address?.address2 !== null && address?.address2 !== '' && !address?.address_name) {
            <tidy-row>
              <tidy-text
                [body]="address?.address2" />
            </tidy-row>
          }
          <tidy-row>
            @if (address?.city !== null && address?.city !== '') {
              <tidy-text
                [helper]="address?.city" />
            }
            @if (address?.zip !== null && address?.zip !== '') {
              <tidy-text
                [helper]="', ' + address?.zip">>
              </tidy-text>
            }
          </tidy-row>
          <tidy-row class="extra-top-padding extra-bottom-padding">
            <tidy-divider />
          </tidy-row>
          <tidy-row class="extra-bottom-padding">
            <tidy-text
              [body]="'Select which RemoteLock location/device(s) to associate with above TIDY property:'" />
          </tidy-row>
          <tidy-row [ngClass]="(didSelectLocation && form.value.location !== 'none') ? 'extra-bottom-padding' : ''">
            <tidy-select
              [icon]="'assets/svg/information-circle.svg'"
              [label]="'Select Location'"
              [items]="locationItems"
              [form]="form.controls.location"
              (optionChange)="selectLocation($event)"
              formControlName="location" />
          </tidy-row>
          @if (didSelectLocation && form.value.location !== 'none') {
            <tidy-row>
              <tidy-text
                [body]="'Select device(s) at'" /><span>&nbsp;</span>
                <tidy-text
                  [body]="remoteAccessAddressName + ':'" />
              </tidy-row>
              @for (device of deviceOptions; track device) {
                <tidy-row>
                  <tidy-checkbox
                    [items]="[device]"
                    [initValue]="device.value"
                    (checkedChange)="device.value = !device.value" />
                </tidy-row>
              }
              @if (deviceOptions?.length == 0) {
                <tidy-row>
                  <tidy-text
                    [helper]="'No devices added for this address.'" />
                </tidy-row>
              }
            }
          </tidy-card>
          @if (errorMessage) {
            <tidy-error-message
              [text]="errorMessage" />
          }
          <tidy-button
            [text]="'Save Changes'"
            [action]="boundSaveChanges"
            class="primary" />
        }
      </tidy-wrapper>
    </form>
  </ng-template>

  @if (!isRightSideContent) {
    <app-scroll-wrapper [templateContent]="content" />
  }

  @if (isRightSideContent) {
    <ion-content class="ion-content-right-column">
      <ng-container *ngTemplateOutlet="content" />
    </ion-content>
  }
